import { memo } from "react";
import { Box, Typography } from "@mui/material";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {nb} from 'date-fns/locale/nb';

interface Props {
    title?: string;
    placeholder?: string;
    name: string;
    value?: Date | null;
    required?: boolean;
    disablePast?: boolean;
    disableFuture?: boolean;
    minDateTime?: Date;
    onChange: (value: any) => void;
}

function DateTimePickerField(
    { 
        title, 
        placeholder, 
        name, 
        value, 
        required, 
        disableFuture, 
        disablePast, 
        minDateTime, 
        onChange 
    }: Props) {
        
    const handleDateChange = (date: Date | null) => {
        if (onChange) {
            onChange(date);
        }
    };

    return (
        <Box>
            {title && (
                <Typography variant="body2" gutterBottom>
                    {title}
                </Typography>
            )}
            <LocalizationProvider adapterLocale={nb} dateAdapter={AdapterDateFns}>
                <DateTimePicker
                    disableFuture={disableFuture}
                    disablePast={disablePast}
                    format="dd.MM.yyyy HH:mm"
                    minDateTime={minDateTime}
                    localeText={{
                        clearButtonLabel: "Nullstill",
                    }}
                    slotProps={{
                        actionBar: {
                            actions: ['clear'],
                        },
                        textField: {
                            required: required,
                            name: name,
                            sx: {
                                fontSize: "body2.fontSize",
                                '& .MuiPickersOutlinedInput-root, & .MuiOutlinedInput-root': {
                                    backgroundColor: 'background.paper',
                                },
                            },
                            fullWidth: true,
                        },
                        desktopPaper: {
                            sx: {
                                borderRadius: "8px",
                            },
                        },
                    }}
                    value={value}
                    onChange={handleDateChange}
                />
            </LocalizationProvider>
        </Box>
    );
}

export default memo(DateTimePickerField);
